<template>
  <div>
     <loading 
     :active.sync="loadingNetwork" 
        :is-full-page="true"
        color="grey"
        ></loading>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white" class= "pt-3">
      <v-btn
        color="primary"
        dark
        class="mb-2"
        @click="addItem()"
        round
      >Add Network</v-btn>
      <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="locationnetworks"
    :fields="exportFields"
    worksheet="export"
    :name="'Networks_'+new Date().getTime()+'.xls'">
    Export to Excel
</download-excel></v-btn>
      <!-- <v-btn color="primary" dark class="mb-2" @click="newDialog=true,basicInformation=true" round >Add Network</v-btn> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    </v-toolbar>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">{{editedItem.modalType}} Network</h1>
      </v-toolbar>
     
      <v-card flat>
       
         <v-card flat >
           <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="addressinfo.name"
                    label="*Network Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="addressinfo.abbreviation"
                    label="Network Abbreviation"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="locationNodes"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="addressinfo.locationNodeId"
                    label="*Associated Network Node"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="regions"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="addressinfo.regionId"
                    label="*Region"
                  ></v-autocomplete>
                </v-flex>
                <v-layout justify-center align-center wrap>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      hide-no-data
                      flat
                      color="primary"
                      :items="networkStatus"
                      v-model="addressinfo.networkStatus"
                      label="*Network Installation Status"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      hide-no-data
                      flat
                      color="primary"
                      :items="backhaulTypes"
                      v-model="addressinfo.backhaulType"
                      label="*Network Backhaul Type"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      color="primary"
                      v-model="addressinfo.isMDU"
                      label="This network has Multi-Dwelling Units"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-layout>
          
          </v-card-text>
        </v-card>


      
       <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary"
          v-if="addressinfo.name&&addressinfo.abbreviation&&addressinfo.locationNodeId&&addressinfo.regionId&&addressinfo.networkStatus&&addressinfo.backhaulType"
          
           round @click="saveNew">Save</v-btn>
           <v-btn round disabled v-else>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Edit item modal -->
    <v-dialog persistent v-model="editDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">{{editedItem.modalType}} Network</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;dataServices=false;tvServices=false; address=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;dataServices=false;tvServices=false; address=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Address Information</v-tab>
          <v-tab
            @click="dataServices=true;basicInformation=false;tvServices=false; address=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Data Services</v-tab>
          <v-tab
            @click="dataServices=false;basicInformation=false;tvServices=true; address=false"
            class="grey--text"
            flat
            round
            color="grey"
          >TV Services</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="basicInformation">
          <v-card-text>
            <!-- <span class="dark-grey--text font-weight-bold">BOB</span> -->
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Network Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.abbreviation"
                    label="Network Abbreviation"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="locationNodes"
                    required
                    item-text="name"
                    item-value="id"
                    prepend-icon="language"
                    v-model="editedItem.locationNodeId"
                    label="*Associated Network Node"
                  >
               </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="networkStatus"
                    v-model="editedItem.networkStatus"
                    label="*Network Installation Status"
                 >
               </v-autocomplete>
                </v-flex>
                 <v-flex xs12 sm6 md6>
                   <v-autocomplete
                   clearable
                   hide-no-data
                   flat
                   color="primary"
                    :items="regions"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.regionId"
                    label="Region"
                  >
               </v-autocomplete>
                </v-flex>
                 <v-flex xs12 sm6 md6>
                  <v-autocomplete
                   clearable
                   hide-no-data
                   flat
                   color="primary"
                    :items="backhaulTypes"
                    v-model="editedItem.backhaulType"
                    label="Network Backhaul Type"
                >
               </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card flat v-show="address">
          <v-card-text>
            <!-- <span class="dark-grey--text font-weight-bold">Address Information</span> -->
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.streetNumber"
                    label="Estate Street Number"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.streetName"
                    label="Estate Street Name"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.suburb" label="Suburb" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.town" label="Town" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.city" label="City" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    required
                    v-model="editedItem.country"
                    label="*Country"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card flat v-show="dataServices">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout col wrap>
                <v-flex xs12 sm6 md6>
                  <v-switch
                    v-model="editedItem.lineRentalIncluded"
                    label="Is the Line Rental included in the Levy?"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.residentialLineRentalValue"
                    type="number"
                    label="*Residential BAS Amount (excl. VAT)"
                  ></v-text-field>
                </v-flex>
               <v-flex xs12 sm6 md6></v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="editedItem.businessLineRentalValue"
                    type="number"
                    label="*Business BAS Amount (excl. VAT)"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-switch
                    v-model="editedItem.routerInstallationFee"
                    label="Is there a Router Installation Fee?"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md6 ></v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.routerInstallationFee">
                  <v-text-field
                    v-model="editedItem.residentialRouterInstallationFeeAmount"
                    label="Residential Installation Fee Amount (Incl. VAT)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.routerInstallationFee">
                  <v-text-field
                    v-model="editedItem.businessRouterInstallationFeeAmount"
                    label="Business Installation Fee Amount (Incl. VAT)"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-switch
                    v-model="editedItem.activationFee"
                    label="Is there a Data Activation fee?"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md4 v-show="!editedItem.activationFee"></v-flex>
                <v-flex xs12 sm6 md6 v-show="editedItem.activationFee">
                  <v-text-field
                    v-model="editedItem.activationFeeAmount"
                    type="number"
                    label="Activation Fee Amount (excl. VAT)"
                  ></v-text-field>
                </v-flex>
                <!-- <v-divider></v-divider> -->
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card flat v-show="tvServices">
          <v-card-text>
            <!-- <span class="dark-grey--text font-weight-bold">TV over Fibre Services</span> -->
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm4 md4>
                  <v-switch v-model="editedItem.tvOverFibre" label="Is TV over Fibre available?"></v-switch>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 sm4 md4 v-if="editedItem.tvOverFibre===true">
                  <v-switch v-model="editedItem.gtuIncluded" label="Is a GTU included?"></v-switch>
                </v-flex>
                <v-flex xs12 sm4 md4 v-if="editedItem.gtuIncluded===false && editedItem.tvOverFibre===true">
                  <v-text-field
                    v-model="editedItem.gtuFee"
                    label="GTU Installation Fee (incl. VAT)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4 v-if="editedItem.gtuIncluded===true"></v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
       <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="locationnetworks"
      :rows-per-page-items="[25, 50, 100, 250]"
      item-key="name"
      align-center
      style="cursor: pointer"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <!-- <v-icon small @click="editItem(props.item)">edit</v-icon> -->

          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td  class="text-xs-left" @click="routerLinkToDetails(props.item)">{{props.item.name}}</td>
        <td  class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.abbreviation}}</td>
        <td
          class="text-xs-center"
           @click="routerLinkToDetails(props.item)"
        >{{props.item.locationNode.name}}</td>
        <td
         @click="routerLinkToDetails(props.item)"
          v-if="props.item.networkStatus==='Live'"
          class="text-xs-center"
        >
          <v-chip small :class="`Live white--text caption my-2`">Live</v-chip>
        </td>
        <td
         @click="routerLinkToDetails(props.item)"
          v-if="props.item.networkStatus==='In Progress'"
          class="text-xs-center"
        >
          <v-chip small :class="`Progress white--text caption my-2`">In Progress</v-chip>
        </td>
        <td
         @click="routerLinkToDetails(props.item)"
          v-if="props.item.networkStatus==='Planned'"
          class="text-xs-center"
        >
          <v-chip small :class="`planned white--text caption my-2`">Planned</v-chip>
        </td>
        <td
         @click="routerLinkToDetails(props.item)"
          v-if="props.item.networkStatus===null"
          class="text-xs-center"
        ></td>
         <td  class="text-xs-center">
          {{props.item.backhaulType}}
        </td>
         <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.residentialRouterInstallationFeeAmount != 0"
        >{{props.item.residentialRouterInstallationFeeAmount|currency}}
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-icon color="cancel">not_interested</v-icon>
        </td>
        <td
         @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.businessRouterInstallationFeeAmount != 0"
        >{{props.item.businessRouterInstallationFeeAmount|currency}}
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-icon color="cancel">not_interested</v-icon>
        </td>
        <td
         @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.numberOfUnits}}</td>
      <td
       @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.liveUnits}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import VueCurrencyFilter from "vue-currency-filter";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  props: ["locationnetworks","isloading"],
  components: {
    loading: Loading
  },
  data() {
    return {  
       addressinfo: {
        id: null,
        networkStatus: "",
        name: "",
        chosenIsps: "",
        chosenFnoCats: [],
        packagesInCat: "",
        lineRentalIncluded: false,
        tvOverFibre: false,
        gtuIncluded: false,
        gtuFee:null,
        activationFee: false,
        activationFeeAmount: null,
        routerInstallationFee: false,
        routerInstallationFeeAmount: null,
        residentialLineRentalValue: 0,
        businessLineRentalValue: 0,
        residentialRouterInstallationFeeAmount: 0,
        businessRouterInstallationFeeAmount: 0,
        locationNode: "",
        locationNodeId: null,
        regionId: null,
        streetNumber: "",
        streetName: "",
        suburb: "",
        town: "",
        city: "",
        country: "",
        geoGeometryType: "",
        geoLongitude: "",
        geoLatitude: "",
        geoHightAboveGroundLevel: null,
        geoJsonId: null,
        isActive: true,
        isDeleted: false,
        isMDU: false,
        backhaulType: ""
      },
       center: { lng: -33.919473, lat: 18.427059},
      zoom: 15,
      y: "top",
      snackbar: false,
      text: "",
      editPolygon: false,
      geocoder: null,
      infoWindowContent: {},
      currentPolyData: [],
      polyData: [],
      newPolyData: [],
      polygon: null,
      key: 0,
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      myStyles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
      backhaulTypes: ["Open Band Wireless", "Licensed Wireless", "Fibre", "Hybrid"],



      editDialog:false,
      regions:[],  
      backhaulTypes: ["Open Band Wireless", "Licensed Wireless", "Fibre"],
      tag: [],  
      loadingNetwork: false,
      basicInformation: false,
      snackbar: false,
      fnoPackagesGenerated: false,
      networkId: "",
      text: "",
      y: "top",
      x: null,
      mode: "",
      address: false,
      internetPackages: false,
      count: [],
      ispOnNetwork: [],
      dataServices: false,
      generatePackagesModal: false,
      tvServices: false,
      packageBatchNumber: [],
      packageISP: [],
      Isps: [],
      packagesInCat: [],
      packageFnoCatsArrays: [],
      fnoPackages: false,
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      networkStatus: ["Planned", "In Progress", "Live"],
      dialog: false,
  exportFields: {
        'name': 'name',
        'node': 'locationNode.name',
        'networkBuildStatus': 'networkStatus',
        'activationFee': 'activationFee',
        'activationFeeAmount': 'activationFeeAmount',
        'routerInstallationFee': 'routerInstallationFee',
        'residentialRouterInstallationFeeAmount': 'residentialRouterInstallationFeeAmount',
        'businessRouterInstallationFeeAmount': 'businessRouterInstallationFeeAmount',
        'unitsPassed': 'numberOfUnits',
        'liveUnits': 'liveUnits'
        },
      newDialog: false,
      pagination: {},
      fnoPackagesHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Package Category",
          align: "center",
          value: "packageCat"
        },
        {
          text: "Package Code",
          align: "center",
          value: "packageCode"
        },
        {
          text: "Base Package Price",
          align: "center",
          value: "basePackagePrice"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Abbreviation",
          align: "center",
          value: "abbreviation"
        },
        {
          text: "Associated Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Network Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Backhaul Type",
          align: "center",
          value: "backhaulType"
        },
        {
          text: "Residential Installation Fee",
          align: "center",
          value: "residentialRouterInstallationFeeAmount"
        },
        {
          text: "Business Installation Fee",
          align: "center",
          value: "businessRouterInstallationFeeAmount"
        },
        {
          text: "Number of Units",
          align: "center",
          value: "numberOfUnits"
        },
        {
          text: "Active Service Accounts",
          align: "center",
          value: "liveUnits"
        }
      ],
      locationNetworks: [],
      locationNodes: [],
      editedIndex: -1,
      packagesFnoCats: [],
      chosenFnoCats: "",
      selectedFnoCats: [],
      chosenIspsArray: [],
      tabs: [
        { name: "addressInformation", displayName: "Address Information" },
        { name: "installation", displayName: "Installation Information" },
        { name: "devices", displayName: "Devices" }
      ],
      chosenIsps: "",
      packagesFnoLocationNetworks: {
        fnoPackageId: "",
        locationNetworkId: ""
      },
      packageFno: [],

      id: "",
      editedItem: {
        id: null,
        networkStatus: "",
        name: "",
        chosenIsps: "",
        chosenFnoCats: [],
        packagesInCat: "",
        lineRentalIncluded: false,
        tvOverFibre: false,
        gtuIncluded: false,
        gtuFee:null,
        activationFee: false,
        activationFeeAmount: null,
        routerInstallationFee: false,
        routerInstallationFeeAmount: null,
        residentialLineRentalValue: 0,
        businessLineRentalValue: 0,
        residentialRouterInstallationFeeAmount: 0,
        businessRouterInstallationFeeAmount: 0,
        locationNode: "",
        locationNodeId: null,
        streetNumber: "",
        streetName: "",
        suburb: "",
        town: "",
        city: "",
        country: "",
        geoGeometryType: "",
        geoLongitude: "",
        geoLatitude: "",
        geoHightAboveGroundLevel: null,
        geoJsonId: null,
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        name: "",
        isActive: true,
        isDeleted: ""
      }
    };
  },

  computed: {
    formattedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    },

    formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
    
  },
 
  methods: {
    fetchRegions(){
      Api().get('/region').then(response=>{
        this.regions=response.data
      })
    },
    fetchLocationNetworks() {           
      this.loadingNetwork = true,
      Api()
        .get("/locationnetworks/basic/active")
        .then(response => {

          this.locationNetworks = response.data;
          console.log('networks', response.data)
       this.loadingNetwork = false
        });
    },
    fetchLocationNodes() {
      Api()
        .get("/locationnodes/active")
        .then(response => {
          this.locationNodes = response.data;
        });
    },

    async routerLinkToDetails(item) { 
      this.loadingNetwork=true
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/locationNetworks/basic/" + this.editedItem.id });
    },
    getAssociatedNetwork(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      return this.editedItem.LocationNode.name;
    },
    getLocations(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.locationNodeId = this.locationNetworks.id;
      this.editedItem = Object.assign({}, item);
      Api()
        .get("/locationNetworks/" + this.editedItem.id)
        .then(response => {
          this.locationNetworks = response.data;
  
        });
    },
    

    initialize() {
      // this.fetchLocationNetworks();
      this.fetchLocationNodes();
      this.fetchRegions()
      // this.fetchAllPackageCategories();
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){
      
        this.editedItem.country = "South Africa"
        this.editedItem.modalType='Add'
        this.addressinfo = {}
      this.basicInformation=true;this.dataServices=false;this.tvServices=false; this.address=false; this.newDialog=true
      }
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedItem = item
      this.editedItem.locationNodeId = item.locationNode.id
      console.log( this.editedItem)
      this.editedItem.modalType='Edit'
      console.log(this.editedItem)
      this.basicInformation=true;this.dataServices=false;this.tvServices=false; this.address=false; this.editDialog=true}
    },

    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().delete("/locationnetworks/" + this.editedItem.id)
      .then(response => {
        this.$emit("locationNetworkSaved");
      })
      }
    },

    close() {
      this.dialog = false;
      this.newDialog = false;
      this.editDialog=false
      this.basicInformation = false;
      this.dataServices = false;
      this.tvServices = false;
      this.internetPackages = false;
      this.fnoPackages = false;
      this.generatePackagesModal = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a network name.");
      }
      if (this.editedItem.locationNodeId == null || this.editedItem.locationNodeId =="") {
        proceed = false;
        confirm("Please select an associated network node.");
      }
       if (this.editedItem.networkStatus == "") {
        proceed = false;
        confirm("Please select a network installation status.");
      }
      if (this.editedItem.streetName == "") {
        proceed = false;
        confirm("Please fill in a street name.");
      }
      if (this.editedItem.country == "") {
        proceed = false;
        confirm("Please fill in the country.");
      }
      if(this.editedItem.lineRentalIncluded == true && (this.editedItem.residentialLineRentalValue == null || this.editedItem.residentialLineRentalValue == "") ) {
        proceed = false;
        confirm("Please fill in the BAS amount (excl. VAT).");
      }
      if (proceed == true) {
      if (!this.editedItem.activationFee) {
        this.editedItem.activationFeeAmount = 0;
        this.editedItem.activationFee = false;
      }
      if (!this.editedItem.tvOverFibre) {
        this.editedItem.tvOverFibre = false;
        this.editedItem.gtuIncluded = false;
        this.editedItem.gtuFee = 0;
      }
      if (!this.editedItem.gtuIncluded) {
        this.editedItem.gtuIncluded = false;
        this.editedItem.gtuFee = 0;
      }
      if (!this.editedItem.routerInstallationFee) {
        this.editedItem.routerInstallationFee = false;
        this.editedItem.routerInstallationFeeAmount = 0;
      }
      if (!this.editedItem.lineRentalIncluded) {
        this.editedItem.lineRentalIncluded = false;
      }
      if (!this.editedItem.geoLongitude) {
        this.editedItem.geoLongitude = "0";
      }
      if (!this.editedItem.geoLatitude) {
        this.editedItem.geoLatitude = "0";
      }
      if (!this.editedItem.geoHightAboveGroundLevel) {
        this.editedItem.geoHightAboveGroundLevel = 0;
      }
      Api().put("/locationnetworks/" + this.editedItem.id, {
        name: this.editedItem.name,
        locationNodeId: this.editedItem.locationNodeId,
        lineRentalIncluded: this.editedItem.lineRentalIncluded,
        businessLineRentalValue: this.editedItem.businessLineRentalValue,
        residentialLineRentalValue: this.editedItem.residentialLineRentalValue,
        tvOverFibre: this.editedItem.tvOverFibre,
        gtuIncluded: this.editedItem.gtuIncluded,
        gtuFee: this.editedItem.gtuFee,
        activationFee: this.editedItem.activationFee,
        activationFeeAmount: this.editedItem.activationFeeAmount,
        routerInstallationFee: this.editedItem.routerInstallationFee,
        residentialRouterInstallationFeeAmount: this.editedItem
            .residentialRouterInstallationFeeAmount,
            businessRouterInstallationFeeAmount: this.editedItem
            .businessRouterInstallationFeeAmount,
        networkStatus: this.editedItem.networkStatus,
        streetNumber: this.editedItem.streetNumber,
        streetName: this.editedItem.streetName,
        suburb: this.editedItem.suburb,
        town: this.editedItem.town,
        city: this.editedItem.city,
        country: this.editedItem.country,
        geoLongitude: this.editedItem.geoLongitude,
        geoLatitude: this.editedItem.geoLatitude,
        geoHightAboveGroundLevel: this.editedItem.geoHightAboveGroundLevel,
        backhaulType: this.editedItem.backhaulType,
        regionId: this.editedItem.regionId,
      }).then(response => {
      this.$emit("locationNetworkSaved");
      })
      this.close();
      this.text = "Network Changes Saved!";
      this.snackbar = true;
      this.editDialog=false
    }
  },
    saveNew() {
      let proceed = true;
      if (this.addressinfo.name == "") {
        proceed = false;
        confirm("Please fill in a network name.");
      }
      if (this.addressinfo.locationNodeId == null) {
        proceed = false;
        confirm("Please select an associated network node.");
      }
       if (this.addressinfo.regionId== null) {
        proceed = false;
        confirm("Please select a region.");
      }
       if (this.addressinfo.networkStatus == "") {
        proceed = false;
        confirm("Please select a network installation status.");
      }
      if (this.addressinfo.backhaulType == "") {
        proceed = false;
        confirm("Please select a network backhaul type.");
      }
      if (proceed == true) {
      if (!this.addressinfo.activationFee) {
        this.addressinfo.activationFeeAmount = 0;
        this.addressinfo.activationFee = false;
      }
      if (!this.addressinfo.tvOverFibre) {
        this.addressinfo.tvOverFibre = false;
        this.addressinfo.gtuIncluded = false;
        this.addressinfo.gtuFee = 0;
      }
      if (!this.addressinfo.gtuIncluded) {
        this.addressinfo.gtuIncluded = false;
        this.addressinfo.gtuFee = 0;
      }
      if (!this.addressinfo.routerInstallationFee) {
        this.addressinfo.routerInstallationFee = false;
        this.addressinfo.routerInstallationFeeAmount = 0;
      }
      if (!this.addressinfo.lineRentalIncluded) {
        this.addressinfo.lineRentalIncluded = false;
      }
      if (!this.addressinfo.geoLongitude) {
        this.addressinfo.geoLongitude = "0";
      }
      if (!this.addressinfo.geoLatitude) {
        this.addressinfo.geoLatitude = "0";
      }
      if (!this.addressinfo.geoHightAboveGroundLevel) {
        this.addressinfo.geoHightAboveGroundLevel = 0;
      }
      Api()
        .post("/locationnetworks", {
          name: this.addressinfo.name,
          abbreviation: this.addressinfo.abbreviation,
          locationNodeId: this.addressinfo.locationNodeId,
          networkStatus: this.addressinfo.networkStatus,
          lineRentalIncluded: this.addressinfo.lineRentalIncluded,
          residentialLineRentalValue: this.addressinfo.residentialLineRentalValue,
          businessLineRentalValue: this.addressinfo.businessLineRentalValue,
          tvOverFibre: this.addressinfo.tvOverFibre,
          gtuIncluded: this.addressinfo.gtuIncluded,
          gtuFee: this.addressinfo.gtuFee,
          activationFee: this.addressinfo.activationFee,
          activationFeeAmount: this.addressinfo.activationFeeAmount,
          routerInstallationFee: this.addressinfo.routerInstallationFee,
          residentialRouterInstallationFeeAmount: this.addressinfo
            .residentialRouterInstallationFeeAmount,
            businessRouterInstallationFeeAmount: this.addressinfo
            .businessRouterInstallationFeeAmount,
          streetNumber: this.addressinfo.streetNumber,
          streetName: this.addressinfo.streetName,
          suburb: this.addressinfo.suburb,
          town: this.addressinfo.town,
          city: this.addressinfo.city,
          country: this.addressinfo.country,
          geoLongitude: this.addressinfo.geoLongitude,
          geoLatitude: this.addressinfo.geoLatitude,
          geoHightAboveGroundLevel: this.addressinfo.geoHightAboveGroundLevel,
          backhaulType: this.addressinfo.backhaulType,
          regionId: this.addressinfo.regionId,
          isMDU: this.addressinfo.isMDU,

        })
        .then(response => {
          this.addressinfo.locationNetworkId = response.data.id;
         
          this.id = response.data.id;          
          this.$emit("locationNetworkSaved");          
          this.initialize();
          this.text = "Network Successfully Saved!";
          this.snackbar = true;
        });
      this.close();
      
    }
    }
  }
};
</script>
<style>
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
.v-chip.Live {
  background: #1ebb2c;
}
.v-chip.Progress {
  background: #df5f09;
}
.v-chip.planned {
  background: #0580e6;
}
.v-chip.activationFee {
  background: #0fc5f3;
}
.v-chip.tvOverFibre {
  background: #b8c417;
}
.v-chip.gtuIncluded {
  background: #dfc013;
}
</style>
